/* eslint-disable @nx/enforce-module-boundaries */
import {  useState } from 'react';
import { CustomEmailDropdown } from '../custom-email-dropdonw';

export const EmailDropdown = ({ ...props }) => {
  const [search, setSearch] = useState();


  

  return (
    <CustomEmailDropdown
      {...props}
      data={[]}
      onSearch={(s) => setSearch(s)}
    />
  );
};
